const News = {

  init() {
    News.loader();
  },

  loader() {
    $('#nasdaq_iframe_news').on('load', function () {
      $('#loader').addClass('fade');

      setTimeout(function () {
        $('#loader').addClass('display-none');
      }, 1100);
    });
  },
}

export default News;
